import React, { createContext, useContext, useState, useCallback } from 'react';
import { getMerchant } from '../services/api';

const MerchantContext = createContext();

export const useMerchant = () => {
  const context = useContext(MerchantContext);
  if (!context) {
    throw new Error('useMerchant must be used within a MerchantProvider');
  }
  return context;
};

export const MerchantProvider = ({ children }) => {
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMerchant = useCallback(async (slug) => {
    console.log('MerchantContext - fetchMerchant called with slug:', slug);
    if (!slug) return;
    
    setLoading(true);
    setError(null);
    
    try {
      console.log('MerchantContext - calling getMerchant API with:', slug);
      const response = await getMerchant(slug);
      console.log('MerchantContext - API response:', response.data);
      setMerchant(response.data);
    } catch (err) {
      console.error('MerchantContext - API error:', err);
      setError(err.response?.data?.detail || 'Failed to fetch merchant');
      setMerchant(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearMerchant = () => {
    setMerchant(null);
    setError(null);
  };

  const value = {
    merchant,
    loading,
    error,
    fetchMerchant,
    clearMerchant
  };

  return (
    <MerchantContext.Provider value={value}>
      {children}
    </MerchantContext.Provider>
  );
};